import React from "react";
import { DatePicker } from "@mui/x-date-pickers";

const DmsDatePicker = ({ desktopModeMediaQuery = "@media (min-width: 0px)", ...props }) => (
    <DatePicker desktopModeMediaQuery={desktopModeMediaQuery} {...props} />
);

export default DmsDatePicker;
